import React from "react";
import { ActionsMenu } from "../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../common/components/ConditionalWrapper";
import { MENU_ACTIONS } from "../../common/components/modals/constants";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import useSearch from "../result/useSearch";
import { getAllCriteria } from "../utils";
import { DateTime } from "./DateTime";
import { SupportLink } from "../header/SupportLink";
import { ClearSearch } from "./ClearSearch";
import { additionalActionsType, criteriaGroupsType, supportLinkType } from "../../common/types/search/search";

interface AdditionalSearchProps {
	additionalActions?: additionalActionsType;
	airportDataEndpoint?: string;
	criteria: criteriaGroupsType;
	namespace: string;
	supportLink?: supportLinkType;
}

export function AdditionalSearch({
	criteria,
	airportDataEndpoint,
	additionalActions,
	namespace,
	supportLink,
}: AdditionalSearchProps) {
	const { onSearch, onClearSearch } = useSearch();
	const { isMobile } = useAccessWindowSize();

	if (criteria.length === 0) {
		return null;
	}

	const additionalSearchCriteria = getAllCriteria(criteria);

	return (
		<div className="actions__action additional-search-filters">
			<DateTime endpoint={airportDataEndpoint} />

			<form className="grid" aria-labelledby="searchTitle">
				{additionalSearchCriteria.map((component, key) => (
					<React.Fragment key={key}>{component}</React.Fragment>
				))}

				<button
					className="btn btn--primary"
					type="button"
					onClick={onSearch}
				>
					Search
				</button>

				<ConditionalWrapper
					condition={isMobile}
					wrapper={(children) => (
						<ActionsMenu id={MENU_ACTIONS}>{children}</ActionsMenu>
					)}
				>
					<SupportLink supportLink={supportLink} />
					<ClearSearch
						onClearSearch={onClearSearch}
						namespace={namespace}
					/>
					{additionalActions}
				</ConditionalWrapper>
			</form>
		</div>
	);
}
